import { render, staticRenderFns } from "./CreateRvsOnlineReport.vue?vue&type=template&id=6b84e14c&scoped=true"
import script from "./CreateRvsOnlineReport.vue?vue&type=script&lang=ts"
export * from "./CreateRvsOnlineReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b84e14c",
  null
  
)

export default component.exports